import AxiosPlugin from '@ricoh/ria.client.core/plugins/axios';

import { SESSION_DURATION } from '~/common/constants/feature/auth/session-timeout';
import { getCSRFTokenFetcher } from '~/services/server/api/anti-forgery';

/** Axios plugin. */
const axiosPlugin = new AxiosPlugin({
  fetchCSRFToken: getCSRFTokenFetcher.handler,
  sessionDuration: SESSION_DURATION,
});

export default axiosPlugin;
